import selectCategoryInBreadcrumbsTrigger from '@coolblue-development/ga4-events/triggers/Breadcrumbs/selectCategoryInBreadcrumbsTrigger';
export const handleOnClick = (breadcrumb, index, totalIndices, trackEvent, subFeature) => {
    const trackingIndex = index + 1;
    trackEvent(selectCategoryInBreadcrumbsTrigger({
        sub_feature: subFeature,
        index: trackingIndex,
        total_indices: totalIndices,
        url: breadcrumb.url,
        redirect: breadcrumb.title,
    }));
};
//# sourceMappingURL=tracking.js.map